<template>
  <div class='location-section-wrapper'>
    <div class='container'>
      <h2 class='location-title h2-title'>
        <span>Де нас знайти?</span>
      </h2>
      <div class='location-container'>
        <div class='location-text'>
          <div class='paragraph-s mb-m'>
            У магазині ви зможете підібрати відповідну з уже наявних моделей або замовити унікальну.
            В обох випадках ми підберемо для вас максимально зручний та якісний медичний або корпоративний одяг.
          </div>
          <div class='paragraph-s locations-contacts'>
            <div class='locations-contacts-item mb-m'>
              <div class='d-flex align-items-center mr-s'>
                <v-icon name="envelope" class='d-flex text-primary'></v-icon>
              </div>
              <span class='mr-s'>Email:</span>
              <a href="mailto:info@musichenko.com" class="app-link">info@musichenko.com</a>
            </div>
            <div class='locations-contacts-item mb-m'>
              <div class='d-flex align-items-center mr-s'>
                <v-icon name="phone" class='d-flex text-primary'></v-icon>
              </div>
              <span class='mr-s'>Телефон:</span>
              <a href="tel:+380672707941" class="app-link">+380672707941</a>
            </div>
            <div class='locations-contacts-item mb-m'>
              <div class='d-flex align-items-center mr-s'>
                <v-icon name="map-marker-alt" class='d-flex text-primary mr-s'></v-icon>
              </div>
              <span class='mr-s'>Адреса:</span>
              <a href='https://g.page/musichenko?share' target="_blank" class='app-link'>Оріхівське шосе 10, Запоріжжя</a>
            </div>
          </div>
        </div>
        <div class='location-wrapper'>
          <google-map></google-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMap from '../common/GoogleMap'
export default {
  name: 'LocationSection',
  components: {
    GoogleMap
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';

.location-section-wrapper {
    background: $white-color;
    padding: 100px 0px;
    .location-title {
      margin-bottom: 20px;
    }
    .location-container {
      display: flex;
      .location-text {
        display: flex;
        flex-direction: column;
        width: calc(50% - 15px);
        margin-right: 15px;
        .locations-contacts {
          .locations-contacts-item {
            display: flex;
            align-content: center;
          }
        }
      }
      .location-wrapper {
        display: flex;
        width: 50%;
      }
    }
}

@media (max-width: $desktop){
}
@media (max-width: $laptop){
  .location-section-wrapper {
    .location-container {
      flex-direction: column;
      .location-text {
        width: 100%;
        margin-right: 0;
        margin-bottom: 15px;
      }
      .location-wrapper {
        width: 100%;
      }
    }
  }
}
@media (max-width: $tablet){
    .location-section-wrapper {
        padding: 50px 0px;
    }
}
@media (max-width: $mobile){

}
</style>
